<template>
  <info-screen class="apiAccept" :title="title" :action="nextScreen" :cancel="cancel" :buttonText="$ml.get('outApiBtnAccept')" :cancelText="$ml.get('outApiBtnReject')" :titleH1="false" :backBtn="true" :headerImg="17">
    <!-- <template slot="bottomLink">
            <custom-button
                    class="bottomButton"
                    :button-text="$ml.get('additionalParamsCancelButton')"
                    border
                    :action="cancel"
            ></custom-button>
        </template> -->
    <template slot="default">
      <div>
        <ul>
          <li v-for="(item, i) in list" :key="`item${i}`" v-html="item"></li>
        </ul>
        <div class="remember">
          <input type="checkbox" id="isAgreeCheckbox" v-model="isRemember" />
          <label for="isAgreeCheckbox" v-html="$ml.get('outApiRemember')"></label>
        </div>
      </div>
    </template>
    <template slot="middle">
      <p class="middleText">{{ help }}</p>
    </template>
  </info-screen>
</template>

<script>
import InfoScreen from '../components/layout/info-screen';
import CustomButton from '../components/ui/custom-button';
import Profile from '../helpers/profile';
import {setConsentData, getApiErrorMessage} from '../helpers/api';
export default {
  name: 'infoSetAdditionalParams',
  components: {CustomButton, InfoScreen},
  data() {
    return {
      title: '',
      list: '',
      help: '',
      isRemember: false,
    };
  },
  created() {
    const client = window.ClientName.slice(0, window.ClientName.indexOf('_external'));
    this.title = this.$ml.get('outApiTitle1') + client + this.$ml.get('outApiTitle2');
    if (window.RequestedScopes.some(i => i.Scope == 'marketplace')) this.list = this.$ml.get('outApiText');
    // console.log(window.LoginHint, window.ClientName, window.ClientURI, window.RequestedScopes, window.CallbackURL);
  },
  methods: {
    nextScreen: function() {
      setConsentData(true, this.isRemember, this.$ml.get('outApiText').join(',')).then(() => {});
    },
    cancel: function() {
      setConsentData(false, this.isRemember, this.$ml.get('outApiText').join(',')).then(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .wrap {
  padding-top: 100px;
}
::v-deep .rightContent {
  padding-top: 40px;
}
::v-deep ul {
  list-style: none;
  margin: 0;
  padding: 0;
  margin-top: 40px;
  li {
    font-weight: 500;
    font-size: 16px;
    line-height: 27px;
  }
}
.middleText {
  font-weight: 300;
  font-size: 14px;
  line-height: 20px;
}
.remember {
  margin-top: 20px;
  font-weight: 300;
  #isAgreeCheckbox {
    float: left;
    padding: initial;
    box-shadow: initial;
    -webkit-appearance: checkbox;
  }
  label {
    font-size: 12px;
    line-height: 1.4em;
    margin-left: 24px;
    display: block;
    a {
      font-size: 12px;
      line-height: 1.5em;
    }
  }
}
@media screen and (max-width: 600px) {
  ::v-deep .rightContent {
    padding-top: 0px;
  }
  ::v-deep .wrap {
    padding-top: 0px;
  }
}
</style>
